import { render, staticRenderFns } from "./GamesAPI.vue?vue&type=template&id=f9c1a206&scoped=true&"
import script from "./GamesAPI.vue?vue&type=script&lang=js&"
export * from "./GamesAPI.vue?vue&type=script&lang=js&"
import style0 from "./GamesAPI.vue?vue&type=style&index=0&id=f9c1a206&lang=scss&scoped=true&"
import style1 from "./GamesAPI.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9c1a206",
  null
  
)

export default component.exports